/**
 * @created on 2018/10/30
 * @author huangtiande
 **/
import { axios as $http, track } from 'cm'
import {
  GetRequest,
  getRunTime
} from '../../../public-resource/libs/utils/index'
import { getPlatform } from 'src/frontend-lib/tools/getPlatform'
import {
  // callWechatPay,
  directAliPay,
  directWechatPay
} from 'src/frontend-lib/lib/payUnit.js'
import { getRequestSign } from '../../../frontend-lib/tools/platformSign'
import Bridge from '../../../public-resource/libs/Bridge/Bridge'
// import Bridge from '../../../frontend-lib/lib/Bridge';
import { askSubmitVerify } from 'src/frontend-lib/tools/aliVerify'
import APIS from './api'
import qs from 'qs'
import PageNewOne from './js/PageNewOne'
// import { Base64 } from 'js-base64'
import './style.scss'

window.sleep = ms => {
  return new Promise(resolve => setTimeout(resolve, ms))
}

import monitor from 'src/frontend-lib/lib/monitor'
;(async function() {
  // 新增页面的业务逻辑都封装在类中，避免这个文件大杂烩
  window.pageNewOne = new PageNewOne()
  await window.sleep(40) // pageNewOne和pageNewTwo有动态渲染html，等它渲染完

  let askliArr = $('.button_div li')
  let active_li = $('.active_div')
  let askTitleInput = $('#ask_title')
  let askContentInput = $('#ask_content')
  let pageList = $('.page')
  let pageOneButton = $('.page_one .next_div button')
  let pageTwoButton = $('.page_two .next_div button')
  let pageTreeButton = $('.page_tree .next_div button')
  let freeButton = $('.page_new_1 .next_div.free')
  let xintanListWrapper = document.querySelector('.page_new_1 .xintan-list-wrp') // 找ta提问的父级包裹层
  let containerDom = $('.container')
  let topHeaderHeight = $('.top-header').outerHeight()
  let pageNum = 1 // 当前页数
  let submitVerifyPromise
  window.pageNum = () => pageNum
  let scrollStatus = true
  let preDivButton = $('.preDiv')
  let pageHistory = [] // 记录访问过的页面
  window.pageHistory = () => pageHistory
  let preStatus = true
  let pageScrollList = []
  window.pageScrollList = () => pageScrollList
  let loginToken
  let userId = 0
  let testDraftId
  let getTokenCallback
  let dingdan_id = null
  let urlparams = GetRequest()
  let cantonal_id = urlparams.cantonal_id || 0
  let UA = getPlatform()
  let _platform
  let reward_ID
  let gobackIcon = $('.yxl-font-back')
  let HOST = getRunTime('//m.xinli001.com')
  let myBrige = new Bridge()
  let invite_user = ''
  let showLeaveStatus = false
  let sendQustionStatus = false
  var payStatus =
    '<div class="payStatus"><div class="y-expert-p show" id="zf"><div class="bd">请根据你的付款情况点击以下按钮</div><div class="ft"><span id="dialog-confirm">已付款</span><span id="dialog-cancel">未付款</span></div></div></div>'
  $('body').append(payStatus)

  var leaveDiv =
    '<div class="leaveDiv"><div class=" y-expert-p show" id="zf"><div class="bd">点击返回会放弃提问，提问草稿会保存在“我的问答”</div><div class="ft"><span id="confirmLeave">确认</span><span id="cancelLeave">取消</span></div></div></div>'
  $('body').append(leaveDiv)

  var loadingDiv =
    '<div class="loadingDiv"><div class="mint-indicator-wrapper" style="padding: 15px;"><span class="mint-indicator-spin"><div class="mint-spinner-snake" style="border-top-color: rgb(204, 204, 204); border-left-color: rgb(204, 204, 204); border-bottom-color: rgb(204, 204, 204); height: 32px; width: 32px;"></div></span> <span class="mint-indicator-text" style="display: none;"></span></div></div>'
  let loadingElemt = $('.loadingDiv')
  $('body').append(loadingDiv)

  if (UA.isYixinliApp && $('#process-app-form').length === 0) {
    let AppPayForm = `<form id="process-app-form" action="yixinli://process_payment?"><input type="hidden" name="data" value="" /></form>`
    $('body').append(AppPayForm)
  }

  $('textarea').removeAttr('autofocus')
  $('textarea').blur()

  $('.reward_rule_t span')
    .eq(0)
    .click(function() {
      window.location.href = IS_APP
        ? 'yixinli://open_article?article_id=100412640'
        : 'https://www.xinli001.com/info/100412640'
    })

  if (window.history.length < 1) {
    $('.yxl-font-back').remove()
  }

  const IS_APP = window.$platform.isYixinliApp

  if (+urlparams.paySuccess === 1) {
    window.close()
    return
  }
  // ios审核处理
  if (+urlparams.sshzv === 1) {
    var newDom = $('.reward_sumit_div').clone()
    newDom.find('#payButton').remove()
    newDom.find('#noRewardButtom').html('发布问题')
    $('.page_four')
      .empty()
      .append(newDom)
  }

  // 向TA提问
  if (urlparams.invite_user) {
    invite_user = urlparams.invite_user
  }

  // 访问埋点
  let Wheight
  window.onload = function() {
    Wheight = $(window).height()
    window.yxl.stat.send({
      name: '提问流程-界面访问'
    })
    // 神策埋点
    track.trackPageView('qa_askquestion_view', {})

    if (!IS_APP && !localStorage.has_askQuestion_Interaction) {
      window.toast('在app发布，可以累积积分，免费换书', 5000)
      localStorage.has_askQuestion_Interaction = true
    }
  }
  window.getTokenFn = function(obj) {
    let newObj = JSON.parse(obj)
    if (newObj.token) {
      loginToken = newObj.token
      getTokenCallback && getTokenCallback(testDraftId)
    } else {
      window.location.href = 'yixinli://open_user_login'
    }
  }
  // APP处理
  if (IS_APP) {
    $('.top-header').remove()
    $('.container').css('padding-top', 0)
    $('.preDiv').addClass('isApp')
    // $('.page').css('padding-top', 0);
    myBrige.call('getToken', {
      callbackName: 'getTokenFn'
    })
    myBrige.call('setTitle', {
      title: document.title
    })
    myBrige.call('isPullRefreshEnable', {
      enable: 0
    })
    myBrige.call('setConfig', {
      isAllowedTitleAnimate: 0
    })
    // window.myBrige = new Bridge({
    //   disInitAppHook: true,
    //   methods: [
    //     {
    //       method: 'appBecomeActiveStatus',
    //       callback(obj) {
    //         if (obj.data.status === 'paySuccess') {
    //           window.localStorage.removeItem('post_reward_dingdan')
    //           window.toast('悬赏成功')
    //           postQuestionFn()
    //         } else if (obj.data.status === 'payFailure') {
    //           window.toast('支付失败')
    //         } else if (obj.data.status === 'h5Disappear') {
    //           return false
    //         } else {
    //           var dingdan_id = window.localStorage.getItem(
    //             'post_reward_dingdan'
    //           )
    //           if (!dingdan_id) {
    //             return
    //           }
    //           loadingElemt.hide()
    //           loadingElemt.show()
    //           $http
    //             .get(APIS.payStatus, {
    //               params: {
    //                 orderNo: dingdan_id
    //               }
    //             })
    //             .then(res => {
    //               if (+res.data.code === 0) {
    //                 loadingElemt.hide()
    //                 window.localStorage.removeItem('post_reward_dingdan')
    //                 window.toast('悬赏成功')
    //                 postQuestionFn()
    //               } else {
    //                 loadingElemt.hide()
    //                 window.localStorage.removeItem('post_reward_dingdan')
    //                 window.toast('您没有完成打赏支付！')
    //               }
    //             })
    //             .catch(err => {
    //               console.log(err)
    //               window.localStorage.removeItem('post_reward_dingdan')
    //               loadingElemt.hide()
    //             })
    //         }
    //       }
    //     }
    //   ]
    // })
  } else {
    // 获取登录信息
    $http
      .get(APIS.isLogin, {
        params: {}
      })
      .then(res => res.data)
      .then(res => {
        if (+res.code === 0) {
          if (!res.data.user.token) {
            window.toast('未登录，稍后为您跳转到登录页面', 3000)
            window.loginTimer = setTimeout(() => {
              let _href = IS_APP
                ? 'yixinli://open_user_login'
                : `${APIS.login}?next=${encodeURIComponent(
                    window.location.href
                  )}`
              window.location.href = _href
            }, 2000)
          }
          if (res.data.user && res.data.user.token) {
            loginToken = res.data.user.token
            userId = res.data.user.id
          }
        }
      })
  }

  // 提问次数检测及支付页跳转
  let askQuestion
  if (window.baseInfo) {
    askQuestion =
      window.baseInfo.toDayPostNum == '' ? 0 : window.baseInfo.toDayPostNum
  } else {
    askQuestion = 3
  }

  for (var i = 0; i < $('.page').length; i++) {
    if (IS_APP) {
      pageScrollList.push(
        $('.page')
          .eq(i)
          .offset().top
      )
    } else {
      pageScrollList.push(
        $('.page')
          .eq(i)
          .offset().top - topHeaderHeight
      )
    }
  }
  ;(function() {
    // 设置page下标
    const pages = document.querySelectorAll('.page')
    pages.forEach((page, index) => {
      page.setAttribute('data-index', index + 1)
    })

    // 设置next_div按钮的next属性，代表点击后跳转到第几页
    const pageOne = document.querySelector('.page_one')
    pageOne.querySelector('.next_div').setAttribute('data-next', 2)

    const pageTwo = document.querySelector('.page_two')
    pageTwo.querySelector('.next_div').setAttribute('data-next', 3)

    const pageThree = document.querySelector('.page_tree')
    pageThree.querySelector('.next_div').setAttribute('data-next', 4)

    const pageNew1 = document.querySelector('.page_new_1')
    pageNew1.querySelector('.next_div.free').setAttribute('data-next', 5)
    pageNew1.querySelector('.xintan-list-wrp').setAttribute('data-next', 6)
  })()

  pageList
    .eq(0)
    .nextAll()
    .hide()

  // 检测是否允许提问及是否悬赏状态
  let hasDingdan_id = window.localStorage.getItem('post_reward_dingdan')
  let hasAsk_id = window.localStorage.getItem('ask_id')
  let draft_id = window.localStorage.getItem('draft_id')
  if (urlparams.pay_callback && hasDingdan_id) {
    $('.page')
      .hide()
      .eq(4)
      .show()
    $('.payStatus').show()
    if (hasAsk_id) {
      reward_ID = hasAsk_id
    }
  }
  if (urlparams.id && !isNaN(urlparams.id)) {
    $('.loadingDiv').show()
    testDraftId = urlparams.id
    testDraft(urlparams.id)
  }

  if (parseInt(askQuestion) >= 2) {
    window.toast('请勿频繁提问刷屏，明天再试试吧')
  }

  // 离开检测
  function unloadFn(e) {
    var e = e || window.event
    e.returnValue = '请确认是否退出？'
  }
  window.removeUnloadHandler = () => {
    window.removeEventListener('beforeunload', unloadFn)
  } // 勿删。PageNewTwo需要。

  $('#confirmLeave').click(function() {
    if (window.history.length > 1) {
      window.history.go(-1)
    } else {
      window.location.href = `${HOST}/qa`
    }
  })

  $('#cancelLeave').click(function() {
    $('.leaveDiv').hide()
  })

  // 检查是否属于草稿
  function testDraft(value) {
    if (IS_APP && !loginToken) {
      getTokenCallback = testDraft
      return
    }
    $http
      .get(APIS.testDraft, {
        params: {
          question_id: value,
          token: loginToken
        }
      })
      .then(res => {
        $('.loadingDiv').hide()
        if (+res.data.code == 0) {
          if (res.data.data.audit_status == 1) {
            $('.page')
              .hide()
              .eq(4)
              .show()
            reward_ID = value
            window.localStorage.setItem('ask_id', reward_ID)
          }
        }
      })
      .catch(err => {
        window.toast(err)
        $('.loadingDiv').hide()
      })
    if (getTokenCallback) {
      getTokenCallback = null
    }
  }

  // 获取标签
  let tagInfo
  $http
    .get(APIS.getTag, qs.stringify({}))
    .then(res => {
      if (+res.data.code === 0) {
        tagInfo = res.data.data
        renderTag()
      } else {
        window.toast('服务器出错，请稍后再试~')
      }
    })
    .catch(err => {
      window.toast('服务器出错，请稍后再试~')
      console.log(err)
      // window.tagErr = err;
    })

  function renderTag() {
    $('.tag_b').empty()
    $('.tag_b').append('<ul></ul><ul></ul>')
    let TagContent = ''
    for (var i = 0; i < tagInfo.length; i++) {
      TagContent += '<li>' + tagInfo[i].name + '</li>'
    }
    $('.tag_b ul')
      .eq(0)
      .append(TagContent)
  }

  // 默认值及默认事件
  let askActiveNum = 1 // 提问状态
  window.askActiveNum = () => askActiveNum // 勿删。PageNewTwo中需要获取
  let askTitle = testCacheFn(window.localStorage.getItem('askTitle')) // 提问标题
  let askContent = testCacheFn(window.localStorage.getItem('askContent')) // 提问内容
  if (testCacheFn(window.localStorage.getItem('askActiveNum')) === '') {
    askActiveNum = 1
  } else {
    askActiveNum = testCacheFn(window.localStorage.getItem('askActiveNum'))
  }
  askliArr
    .eq(askActiveNum)
    .removeClass('active')
    .siblings()
    .addClass('active')
  if (parseInt(askActiveNum) === 1) {
    active_li.css('left', '0.7rem')
  } else {
    active_li.css('left', '2.4667rem')
  }
  askTitleInput.val(askTitle)
  askContentInput.val(askContent)
  askTitleInput.css('height', askTitleInput[0].scrollHeight + 2)

  if (UA.isiPhone) {
    _platform = 'ios'
  } else if (UA.isAndroid) {
    _platform = 'android'
  } else {
    _platform = ''
  }
  if (UA.isWechat) {
    $('.pay_div li')
      .eq(1)
      .remove()
    $('.pay_div li').css('width', '100%')
  }

  // 返回
  gobackIcon.click(function() {
    if (showLeaveStatus) {
      $('.leaveDiv').show()
    } else {
      if (window.history.length > 1) {
        window.history.go(-1)
      } else {
        window.location.href = `${HOST}/qa`
      }
    }
  })

  if (window.history.length < 1 && document.referrer === '') {
    $('.yxl-font-back').hide()
    $('.top-header span').css('color', '#ff745b')
  }

  // 跳转到首页
  $('.top-header span').click(function() {
    window.location.href = `${HOST}/qa`
  })

  // 处理滚动异常
  // containerDom.scroll(function() {
  //   // if (pageNum === 4) {
  //   if (!scrollStatus) {
  //     containerDom.scrollTop(pageScrollList[pageNum - 1]);
  //   }
  //   // }
  // });
  let bodyTimer
  $(window).resize(function() {
    if (Wheight === $(window).height()) {
      clearTimeout(bodyTimer)
      bodyTimer = setTimeout(function() {
        containerDom.stop().animate(
          {
            scrollTop: pageScrollList[pageNum - 1]
          },
          200
        )
      }, 200)
    }
  })

  // 验证是否过了缓存时间
  function testCacheFn(e) {
    let newObj
    var newTime = new Date()
    var newTimeValue = newTime.getTime()
    var cacheTime = 24 * 3600 * 1000
    try {
      newObj = JSON.parse(e)
    } catch (error) {
      newObj = ''
    }
    if (!newObj) {
      return ''
    } else if (!newObj.content) {
      return ''
    } else if (cacheTime + parseInt(newObj.time) < newTimeValue) {
      return ''
    } else {
      return newObj.content
    }
  }

  // 上一步功能
  preDivButton.click(function() {
    if (pageNum === 1) {
      return false
    } else if (preStatus) {
      preStatus = false
      payDiv.hide()
      if (pageNum - 1 === 1) {
        preDivButton.hide()
      }
      // $('.page')
      //   .eq(pageNum)
      //   .show()
      pageNum--
      if (pageNum !== 4) {
        scrollStatus = true
      }
      const prePage = pageHistory.pop() // 拿到上一页地址，同时将最新记录的页面出栈
      containerDom.stop().animate(
        {
          scrollTop: pageScrollList[prePage - 1]
        },
        500,
        function() {
          preStatus = true
          pageList
            .eq(prePage - 1)
            .nextAll()
            .hide()
        }
      )
    }
  })
  let scrollFn = function(scrollValue, nextPage, currentPage) {
    containerDom.stop().animate(
      {
        scrollTop: pageScrollList[nextPage - 1]
      },
      500,
      function() {
        // 记录访问过的页面
        pageHistory.push(currentPage)
        if (nextPage === 5) {
          // 普通问答
          window.yxl.stat.send({
            name: '答疑馆',
            properties: {
              页面: '普通问答提问流程'
            }
          })
        }
        if (nextPage === 6) {
          // 心探问答
          window.yxl.stat.send({
            name: '答疑馆',
            properties: {
              页面: '心探教练提问流程'
            }
          })
        }
      }
    )
    // android软键盘弹起时，触发不了回调
    // pageList
    //   .eq(nextPage - 1)
    //   .nextAll()
    //   .hide()
    preDivButton.show()
    if ([4, 5, 6].includes(nextPage)) {
      preDivButton.hide()
      scrollStatus = false
    }
  }
  // 匿名/实名选择功能
  askliArr.click(function() {
    $(this)
      .siblings()
      .fadeIn(300)
    $(this)
      .addClass('active')
      .siblings()
      .removeClass('active')
    if ($(this).index() === 0) {
      active_li.css('left', '0.7rem')
      askActiveNum = 1
    } else {
      // active_li.css('left', '1.94667rem');
      active_li.css('left', '2.4667rem')
      askActiveNum = 0
    }
  })
  // 提问标题检测
  let testAskTitleInput = function() {
    // askTitleInput.val(askTitleInput.val().trim())
    askTitleInput.css('height', 'auto')
    askTitleInput.css('height', askTitleInput[0].scrollHeight + 2)
    if (askTitleInput.val().length > 25) {
      askTitleInput.css('color', 'red')
      // var newValue = askTitleInput.val().slice(0, 25);
      pageOneButton.css('background', '#6D7588')
    } else if (
      askTitleInput.val().length >= 5 &&
      askTitleInput.val().trim() !== ''
    ) {
      askTitleInput.css('color', '#BCC2CF')
      window.addEventListener('beforeunload', unloadFn)
      pageOneButton.css('background', '#6D7588')
    } else {
      askTitleInput.css('color', '#BCC2CF')
      pageOneButton.css('background', '#BCC2CF')
    }
  }
  testAskTitleInput()
  askTitleInput.on('input', testAskTitleInput)
  pageOneButton.click(function() {
    if (!loginToken) {
      window.removeEventListener('beforeunload', unloadFn)
      window.toast('未登录，稍后为您跳转到登录页面', 3000)
      window.loginTimer = setTimeout(() => {
        let _href = IS_APP
          ? 'yixinli://open_user_login'
          : `${APIS.login}?next=${encodeURIComponent(window.location.href)}`
        window.location.href = _href
      }, 2000)
      return false
    }
    if (parseInt(askQuestion) >= 2) {
      window.toast('请勿频繁提问刷屏，明天再试试吧')
    } else if (
      askTitleInput.val().trim() === '' ||
      askTitleInput.val().length < 5
    ) {
      return false
    } else if (askTitleInput.val().length > 25) {
      window.toast('请输入5-25字符之间的问题标题~')
      return false
    } else {
      $('.page')
        .eq(pageNum)
        .show()
      var scrollValue =
        $('.page')
          .eq(pageNum)
          .offset().top - topHeaderHeight
      pageNum++
      let newTime = new Date()
      let newTimeValue = newTime.getTime()
      let askTitleCache = {
        time: newTimeValue,
        content: askTitleInput.val().trim()
      }
      let askActiveNumCache = {
        time: newTimeValue,
        content: askActiveNum
      }
      window.localStorage.setItem('askTitle', JSON.stringify(askTitleCache))
      window.localStorage.setItem(
        'askActiveNum',
        JSON.stringify(askActiveNumCache)
      )

      const nextPage = +document
        .querySelector('.page_one')
        .querySelector('.next_div').dataset.next
      const currentPage = +document.querySelector('.page_one').dataset.index
      scrollFn(scrollValue, nextPage, currentPage)

      // 神策埋点
      track.trackPageView('qa_askquestion_description_view', {})
    }
  })

  // 提问内容检测
  let testAskContentInput = function() {
    if (askContentInput.val().length >= 400) {
      var newValue = askContentInput.val().slice(0, 400)
      askContentInput.val(newValue)
      pageTwoButton.css('background', '#6D7588')
    } else if (
      askContentInput.val().length >= 20 &&
      askContentInput.val().trim() !== ''
    ) {
      pageTwoButton.css('background', '#6D7588')
    } else {
      pageTwoButton.css('background', '#BCC2CF')
    }
  }
  testAskContentInput()
  askContentInput.on('input', testAskContentInput)
  askContentInput.blur(function() {
    setTimeout(function() {
      containerDom.scrollTop(pageScrollList[1])
    }, 200)
  })

  pageTwoButton.click(function() {
    if (
      askContentInput.val().trim() === '' ||
      askContentInput.val().trim().length < 20
    ) {
      askContentInput.val(askContentInput.val().trim())
      window.toast('问题描述不能为空或少于20个字~')
      return false
    } else {
      $('.page')
        .eq(pageNum)
        .show()
      var scrollValue =
        $('.page')
          .eq(pageNum)
          .offset().top - topHeaderHeight
      pageNum++
      let newTime = new Date()
      let newTimeValue = newTime.getTime()
      let askContentCache = {
        time: newTimeValue,
        content: askContentInput.val().trim()
      }
      window.localStorage.setItem('askContent', JSON.stringify(askContentCache))

      const nextPage = +document
        .querySelector('.page_two')
        .querySelector('.next_div').dataset.next
      const currentPage = +document.querySelector('.page_two').dataset.index
      scrollFn(scrollValue, nextPage, currentPage)
    }
  })

  // 选择标签功能
  let firstTag
  window.firstTag = () => firstTag // 勿删。PageNewTwo中需用到。
  let secondTag = []
  window.secondTag = () => secondTag // 勿删。PageNewTwo中需用到。
  let firstTagUl = $('.first_tag .tag_b ul')
  let firstTagList = $('.first_tag .tag_b')
  let firstTagTitle = $('.first_tag .tag_t')
  let second_tagCt = $('.second_tag')

  function renderSecondTag(i) {
    $('.tag_b ul')
      .eq(1)
      .empty()
    let tagDom = ''
    let tagList = tagInfo[i].child_tags
    for (var j = 0; j < tagList.length; j++) {
      tagDom +=
        '<li id="' +
        tagList[j].custome_tag_id +
        '">' +
        tagList[j].name +
        '</li>'
    }
    $('.tag_b ul')
      .eq(1)
      .append(tagDom)
  }

  $('.tag_b').on('click', 'li', function() {
    if (
      $(this)
        .parent()
        .index() === 0
    ) {
      firstTagTitle.find('p').html($(this).html())
      $(this)
        .addClass('active')
        .siblings()
        .removeClass('active')
      firstTag = tagInfo[$(this).index()].custome_tag_id
      second_tagCt.hide()

      // 神策埋点
      track.trackEvent('qa_askquestion_tags_click', {
        first_class_tag: tagInfo[$(this).index()].name,
        second_class_tag: ''
      })

      $(this)
        .parent()
        .hide()
      renderSecondTag($(this).index())
      $('.tag_b ul')
        .eq(1)
        .fadeIn() // 兼容ios
      firstTagTitle.find('span').show()
    } else {
      if ($(this).hasClass('active')) {
        $(this).removeClass('active')
        secondTag.splice(secondTag.indexOf($(this).attr('id')), 1)
      } else {
        if (secondTag.length >= 3) {
          window.toast('最多选3个标签')
          return
        }
        $(this).addClass('active')
        secondTag.push($(this).attr('id'))
      }
      if (secondTag.length >= 1) {
        $('.page_tree .next_div').show()
        pageTreeButton.css('background', '#6D7588')
      } else {
        $('.page_tree .next_div').hide()
      }

      // 神策埋点
      track.trackEvent('qa_askquestion_tags_click', {
        first_class_tag: firstTag,
        second_class_tag: tagInfo[$(this).index()].name
      })
    }
  })
  firstTagTitle.click(function() {
    if (firstTag !== '') {
      $('.page_tree .next_div').hide()
      $('.tag_b ul')
        .eq(0)
        .fadeIn()
      $('.tag_b ul')
        .eq(1)
        .hide()
      secondTag = []
      firstTagTitle.find('span').hide()
    }
  })

  let postQuestionStatus = false

  // 提交问题
  function submitQuestion(callback) {
    if (postQuestionStatus) return // 避免重复点击
    postQuestionStatus = true
    $('.loadingDiv').hide()
    $('.loadingDiv').show()
    let params = {
      tag_id: firstTag, // 一级标签ID
      tags: secondTag.join(','),
      token: loginToken,
      content: askContentInput.val().trim(),
      title: askTitleInput.val().trim(),
      is_niming: askActiveNum, // 匿名1,实名0
      _platform: 'm',
      _version: '5.5.0',
      laiyuan: IS_APP ? _platform : 'm',
      nc_sessionid: submitVerifyPromise.sessionId,
      nc_token: submitVerifyPromise.token,
      nc_sig: submitVerifyPromise.sig,
      nc_scene: window.NVC_Opt.scene,
      nc_appkey: window.NVC_Opt.appkey
    }

    if (cantonal_id) {
      params.cantonal_id = cantonal_id
    }

    let platFormSign = getRequestSign(
      params,
      '49da2fb42b5655d69f9449ca2fe30e40'
    )

    let newParams = Object.assign(platFormSign.params, {
      sign: platFormSign.sign
    })
    $http
      .post(APIS.postQuestion, qs.stringify(newParams), {
        timeout: 20000
      })
      .then(res => {
        let _res = res.data
        let _code = +_res.code
        if (_code === 0) {
          showLeaveStatus = true
          window.removeEventListener('beforeunload', unloadFn)
          reward_ID = _res.data.id
          window.localStorage.removeItem('askContent')
          window.localStorage.removeItem('askTitle')
          window.localStorage.removeItem('askActiveNum')
          window.localStorage.setItem('ask_id', _res.data.id)
          typeof callback === 'function' && callback()
        } else {
          window.toast(_res.message)
        }
      })
      .catch(err => {
        window.toast(err)
      })
      .finally(() => {
        postQuestionStatus = false
        $('.loadingDiv').hide()
      })
  }

  pageTreeButton.click(function() {
    if (
      askTitleInput.val().length > 25 ||
      askTitleInput.val().trim() === '' ||
      askTitleInput.val().length < 5
    ) {
      window.toast('请输入5-25字符之间的问题标题~')
      return false
    } else if (
      askContentInput.val().trim() === '' ||
      askContentInput.val().trim().length < 20
    ) {
      window.toast('问题描述不能为空或少于20个字~')
      return false
    }
    if (firstTag && secondTag.length >= 1) {
      if (!submitVerifyPromise) {
        window.toast('请先完成验证')
        return
      }
    } else {
      return false
    }
    $('.page')
      .eq(pageNum)
      .show()
    var scrollValue =
      $('.page')
        .eq(pageNum)
        .offset().top - topHeaderHeight
    pageNum++

    const nextPage = +document
      .querySelector('.page_tree')
      .querySelector('.next_div').dataset.next
    const currentPage = +document.querySelector('.page_tree').dataset.index
    scrollFn(scrollValue, nextPage, currentPage)
  })

  freeButton.click(function() {
    // 先存草稿，存完再滚动到下一页
    submitQuestion(() => {
      const pageEl = document.querySelector('.page_new_1')
      const nextPage = +pageEl.querySelector('.next_div.free').dataset.next
      const currentPage = +pageEl.dataset.index
      // 先将下一页显示
      document.querySelector(`[data-index="${nextPage}"]`).style.display =
        'block'
      // 记录pageNum
      pageNum++
      // 然后才能滚动
      scrollFn(0, nextPage, currentPage)
    })
  })

  xintanListWrapper.addEventListener('click', e => {
    // 点击“找ta解读”才处理
    const target = e.target
    if (
      target.classList.contains('next_div') &&
      target.classList.contains('no-free')
    ) {
      const pageEl = document.querySelector('.page_new_1')
      const nextPage = +pageEl.querySelector('.xintan-list-wrp').dataset.next
      const currentPage = +pageEl.dataset.index
      // 先将下一页显示
      document.querySelector(`[data-index="${nextPage}"]`).style.display =
        'block'
      // 记录pageNum
      pageNum++
      // 然后才能滚动
      setTimeout(() => {
        scrollFn(0, nextPage, currentPage)
      }, 300)
    }
  })

  // 悬赏金额选择
  var rewardLi = $('.reward li')
  var rewarInput = $('#rewarInput')
  var inputText = $('.inputText')
  var payDiv = $('.pay_div')
  var payDivLi = payDiv.find('li')
  var showRewardTxtBtn = $('#showRewardTxtBtn')
  var reward_rule_text = $('.reward_rule_text')
  var agreeText = $('.agreeText')
  var agreeRewardStatus = false
  var payButton = $('#payButton')
  var priceList = [10, 20, 30]
  var rewardLiNum
  var price
  rewardLi.click(function() {
    $(this)
      .addClass('active')
      .siblings()
      .removeClass('active')
    payButton.show()
    rewardLiNum = $(this).index()
    if ($(this).index() === 3) {
      payDiv.hide()
    } else {
      price = priceList[$(this).index()]
    }
  })
  $('.pay_close').click(function() {
    payDiv.slideUp(500)
  })

  // 支付方式弹框
  payButton.click(function() {
    if (rewardLiNum !== 3) {
      price = priceList[rewardLiNum]
    } else {
      price = parseFloat($('#rewarInput').val())
    }
    if (price) {
      payDiv.slideDown(500)
    } else {
      window.toast('请选择或输入悬赏金额~')
    }
  })
  rewarInput.on('input', function() {
    if (parseInt($(this).val()) === 0) {
      $(this).val('')
    }
    if (
      $(this)
        .val()
        .indexOf('.') > -1 &&
      $(this)
        .val()
        .split('.').length >= 2
    ) {
      var newValue = parseFloat($(this).val())
      $(this).val('')
      $(this).val(newValue)
    }
    this.value = this.value.replace(/[^\d\.]/g, '')
    this.value = this.value.replace(/^\./g, '')
    this.value = this.value.replace(/\.{2,}/g, '.')
    this.value = this.value
      .replace('.', '$#$')
      .replace(/\./g, '')
      .replace('$#$', '.')
    this.value = this.value.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')
    var reg = /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/
    if (reg.test($(this).val())) {
      if (parseInt($(this).val()) === 0) {
        $(this).val('')
      }
      let max = $(this)[0].max ? $(this)[0].max : 100
      if (parseFloat($(this).val()) >= max) {
        $(this).val($(this)[0].max)
      }
    }
    if ($(this).val().length !== 0) {
      inputText.show()
    } else {
      inputText.hide()
    }
  })
  rewarInput.blur(function() {
    var newValue = parseFloat(rewarInput.val())
    rewarInput.val('')
    rewarInput.val(newValue)

    // fix：IOS，软键盘消失后，页面底部留白
    if (window.$platform.isiOS) {
      setTimeout(() => {
        const t =
          document.documentElement.scrollTop || document.body.scrollTop || 0
        window.scrollTo(0, Math.max(t - 1, 0))
      }, 200)
    }
  })
  // 悬赏规则展开收缩
  showRewardTxtBtn.click(function() {
    if (reward_rule_text.css('display') === 'none') {
      showRewardTxtBtn.html(
        '收起<i class="yxlicon icon-shangjiantou"></i></span>'
      )
      reward_rule_text.slideDown(500)
    } else {
      showRewardTxtBtn.html(
        '查看<i class="yxlicon icon-xiajiantou"></i></span>'
      )
      reward_rule_text.slideUp(500)
    }
  })

  // 悬赏方式选择
  payDivLi.removeClass('active')
  let createDingdaning = false
  payDivLi.click(function() {
    if (createDingdaning) return
    if (!price || price < 1) {
      window.toast('请勿违规操作！')
    } else if (!agreeText.find('span').hasClass('active')) {
      window.toast('请同意《问答用户悬赏/打赏用户协议》')
    } else {
      if (!reward_ID) {
        window.toast('请走正常流程！')
        window.location.reload()
        return false
      }
      // 支付埋点
      window.yxl.stat.send({
        name: '问答-提问页「微信/支付宝支付」点击'
      })

      // 创建订单参数
      let params = {
        price: price * 100, // 价格，1-100之间
        payWay: '', // 支付方式，alipay | weixin
        objectId: reward_ID, // 对象ID
        // object_name: 'qa.post.reward', // 允许值: "qa.reward", "qa.post.reward"
        source: 'yixinli_mobi', // 支付形式，yixinli_pc | yixinli_mobi | yixinli_app
        payMode: ''
      }
      if (UA.isPc) {
        params.source = 'yixinli_pc'
      }
      if (IS_APP) {
        params.source = 'yixinli_app'
      } else {
        params.token = loginToken
      }
      if ($(this).index() === 0) {
        params.payWay = 'weixin'
      } else {
        params.payWay = 'alipay'
      }
      if (IS_APP) {
        params.payMode = 'APP'
      } else if (UA.isWechat) {
        params.payMode = 'JSAPI'
      } else {
        params.payMode = params.payWay === 'weixin' ? 'MWEB' : 'WAP'
      }
      if (UA.isWechat && params.payWay === 'weixin') {
        params.openId = window.baseInfo.wxcode // 微信端支付需要传入
      }
      params.successRedirect = `${window.location.protocol}${HOST}/qa/post-question-view?invite_user=${invite_user}&cantonal_id=${cantonal_id}&pay_callback=1`

      let rewardApi = APIS.rewardApi

      createDingdaning = true
      // if (UA.isPc && !UA.isYixinliApp && !UA.isWechat) {
      //   // 针对PC悬赏的回调
      //   if (urlparams.paySuccess == '1') {
      //     params.successRedirect = window.location.href
      //   } else if (
      //     Object.keys(urlparams).length === 0 &&
      //     !urlparams.paySuccess
      //   ) {
      //     params.successRedirect = window.location.href + '?paySuccess=1'
      //   } else if (Object.keys(urlparams).length > 0 && !urlparams.paySuccess) {
      //     params.successRedirect = window.location.href + '&paySuccess=1'
      //   }
      //   params.source = 'yixinli_pc'
      //   var newWindow = window.open('about:blank')
      //   $http
      //     .post(rewardApi, qs.stringify(params))
      //     .then(res => {
      //       createDingdaning = false
      //       if (+res.data.code == 0) {
      //         let post_reward_Id = res.data.data.orderNo
      //         window.localStorage.setItem('post_reward_dingdan', post_reward_Id)
      //         if (!UA.isYixinliApp && res.data.data.pay_action) {
      //           $('.payStatus').show()
      //           newWindow.location.href = res.data.data.pay_action
      //         }
      //       } else {
      //         window.toast(res.data.message)
      //       }
      //     })
      //     .catch(err => {
      //       createDingdaning = false
      //       window.toast(err)
      //     })
      // }
      $http
        .post(rewardApi, qs.stringify(params))
        .then(res => {
          createDingdaning = false
          monitor.stat({
            logType: 'pay',
            title: '问答-支付日志',
            message: qs.stringify(params),
            url: rewardApi,
            code: res.data.code,
            payParameters: qs.stringify(res.data),
            resultMessage: 'payApiResponse',
            userId: userId
          })
          if (+res.data.code === 0) {
            let post_reward_Id = res.data.data.orderNo
            window.localStorage.setItem('post_reward_dingdan', post_reward_Id)
            let payParameters = res.data.data.result.body
            if (UA.isWechat && params.payWay === 'weixin') {
              function onBridgeReady() {
                WeixinJSBridge.invoke(
                  'getBrandWCPayRequest',
                  payParameters,
                  function(res) {
                    monitor.stat({
                      logType: 'pay',
                      title: '问答-支付日志',
                      message: JSON.stringify(params),
                      url: location.href,
                      code: res.err_msg,
                      payParameters: JSON.stringify(payParameters),
                      resultMessage: res.err_msg,
                      userId: userId,
                      UA: navigator.userAgent
                    })

                    if (res.err_msg == 'get_brand_wcpay_request:ok') {
                      window.toast('支付成功', 1000, function() {
                        postQuestionFn()
                      })
                    }
                    if (res.err_msg == 'get_brand_wcpay_request:cancel') {
                      window.toast('取消支付')
                    } else if (res.err_msg == 'get_brand_wcpay_request:fail') {
                      window.toast('支付失败')
                    }
                  }
                )
              }
              if (typeof WeixinJSBridge === 'undefined') {
                if (document.addEventListener) {
                  document.addEventListener(
                    'WeixinJSBridgeReady',
                    onBridgeReady,
                    false
                  )
                } else if (document.attachEvent) {
                  document.attachEvent('WeixinJSBridgeReady', onBridgeReady)
                  document.attachEvent('onWeixinJSBridgeReady', onBridgeReady)
                }
              } else {
                onBridgeReady()
              }
              return
            }

            if (!UA.isYixinliApp && params.payWay === 'weixin') {
              $('.payStatus').show()
              directWechatPay(payParameters.mwebUrl, params.successRedirect)
              return
            }

            if (!UA.isYixinliApp && params.payWay === 'alipay') {
              $('.payStatus').show()
              directAliPay(payParameters)
              return
            }

            if (UA.isYixinliApp) {
              document
                .querySelector('#process-app-form input[name="data"]')
                .setAttribute('value', res.data.data.result)
              document.querySelector('#process-app-form').submit()
            }
          } else {
            window.toast(res.data.message)
          }
        })
        .catch(err => {
          createDingdaning = false
          window.toast(err)

          monitor.stat({
            logType: 'pay',
            title: '问答-支付日志',
            message: JSON.stringify(err),
            url: location.href,
            code: '',
            payParameters: JSON.stringify(params),
            resultMessage: '',
            userId: userId
          })
        })

      $(this)
        .addClass('active')
        .siblings()
        .removeClass('active')
    }
  })
  agreeText.find('span').click(function() {
    if ($(this).index() === 0) {
      if ($(this).hasClass('active')) {
        $(this).removeClass('active')
        agreeRewardStatus = false
        payButton.css('background', '#BCC2CF')
      } else {
        $(this).addClass('active')
        agreeRewardStatus = true
        payButton.css('background', '#6D7588')
      }
    } else {
      window.location.href = 'https://m.xinli001.com/qa/reward/agreement'
    }
  })

  // 支付确认
  $('#dialog-confirm').click(function() {
    let dingdan_id = window.localStorage.getItem('post_reward_dingdan')
    if (!dingdan_id) {
      window.toast('请勿违规操作！')
      return false
    }
    $('.loadingDiv').hide()
    $('.loadingDiv').show()
    $http
      .get(APIS.payStatus, {
        params: {
          orderNo: dingdan_id
        }
      })
      .then(res => {
        if (+res.data.code === 0) {
          $('.loadingDiv').hide()
          $('.payStatus').hide()
          window.localStorage.removeItem('post_reward_dingdan')
          window.toast('支付成功')
          postQuestionFn()
        } else {
          $('.loadingDiv').hide()
          $('.payStatus').hide()
          // window.localStorage.removeItem('post_reward_dingdan');
          window.toast('您没有完成支付！')
        }
      })
      .catch(err => {
        // window.localStorage.removeItem('post_reward_dingdan');
        $('.loadingDiv').hide()
      })
  })

  $('#dialog-cancel').click(function() {
    $('.payStatus').hide()
  })

  // 不悬赏直接发布
  $('#noRewardButtom').click(function() {
    postQuestionFn()
  })

  function postQuestionFn() {
    if (sendQustionStatus) {
      return
    }

    sendQustionStatus = true

    let params = {
      question_id: reward_ID,
      token: loginToken
    }
    let newInvite_user = window.localStorage.getItem('invite_user')
    if (newInvite_user && !invite_user) {
      invite_user = newInvite_user
    }
    if (invite_user) {
      params.invite_user = invite_user
    }

    $('.loadingDiv').show()
    $http
      .post(APIS.postQuestionRelease, qs.stringify(params))
      .then(res => {
        sendQustionStatus = false
        if (+res.data.code === 0) {
          // 神策埋点（模拟进入提问成功页访问）
          let dingdan_id = window.localStorage.getItem('post_reward_dingdan')
          track.trackPageView('qa_askquestion_successful_view', {
            qa_id: params.question_id,
            is_free: dingdan_id ? true : false,
            to_user_is_anonymity: window.askActiveNum ? true : false,
            bonus_amount: price ? price * 100 : 0,
            invited_id: params.invite_user
          })

          $('.loadingDiv').hide()
          $('.payStatus').hide()
          window.toast('发布成功')
          window.localStorage.removeItem('draft_id')
          window.localStorage.removeItem('invite_user')
          let jumpUrl =
            window.baseInfo.askResultUrl + '?business_id=' + reward_ID || ''
          if (cantonal_id) {
            jumpUrl += `?cantonal_id=${cantonal_id}&business_id=${reward_ID}`
          }
          if (+urlparams.sshzv === 1) {
            window.location.href = jumpUrl + '&sshzv=1'
          } else {
            window.location.href = jumpUrl
          }
        } else {
          $('.loadingDiv').hide()
          $('.payStatus').hide()
          window.toast('发布失败，' + res.data.message)
        }
      })
      .catch(err => {
        sendQustionStatus = false
        $('.loadingDiv').hide()
        window.toast(err)
      })
  }
  // 放到最后是为了不用背await堵塞其他JS执行
  submitVerifyPromise = await askSubmitVerify('#aliVerify')
})()



// WEBPACK FOOTER //
// ./src/pages/ask/questionProcess/index.js